import {PayloadAction} from "@reduxjs/toolkit"
import {Dispatch} from "react"
import {ActionTypes} from "../../redux/Order/OrderReducer";
import {OrderRepositoryInstance} from "../../repository/Order/OrderRepository";
import {CheckoutRequest, CheckoutRequestNewUser} from "../../shared/entities/Client/CheckoutRequest";
import {CartService} from "../Cart/CartService";

/**
 * ClientService.
 *
 */
export class OrderService {
    private dispatch: Dispatch<PayloadAction<any>>
    private repository = OrderRepositoryInstance
    private cartService: CartService;

    constructor(dispatch: Dispatch<PayloadAction<any>>) {
        this.dispatch = dispatch
        this.cartService = new CartService(this.dispatch)
    }

    public async getOrder(id: number, unregistered: boolean, email?: string) {
        return this.repository.getOrder(id, unregistered, email).then(res => {
            this.dispatch({
                type: ActionTypes.ORDER,
                payload: res?.Some || []
            })
            return res
        })
    }

    public async getPaperOrder(id: any) {
        return this.repository.getPaperOrder(id).then(res => {
            this.dispatch({
                type: ActionTypes.PAPER_ORDER,
                payload: res?.Some || []
            })
            return res
        })
    }


    public async checkNamePoVins(dealershipId: number, namePo: string) {
        return this.repository.checkNamePoVins(dealershipId, namePo)
    }

    public async orderCheckout(data: CheckoutRequest, noRemoveCart?: boolean) {
        return await this.repository.orderCheckout(data).then(res => {
            // localStorage.removeItem('cartItems');
            // this.dispatch({type: "REMOVE_ALL_CART", payload: []});
            if (!noRemoveCart) {
                this.cartService.removeAllCart()
            }
            this.dispatch({
                type: ActionTypes.ORDER_CHECKOUT,
                payload: res.Some
            })
            return res
        })
    }

    public async reorder(data: any) {
        return await this.repository.reorder(data).then(res => {
            return res
        })
    }

    public async createOrderNewUser(data: CheckoutRequestNewUser) {
        return await this.repository.createOrderNewUser(data).then(res => {
            if (!res?.None) {
                this.cartService.removeAllCart()
            }
            this.dispatch({
                type: ActionTypes.ORDER_CHECKOUT,
                payload: res.Some
            })
            return res
        })
    }

    public async invoicePdf(data: any) {
        return this.repository.invoicePdf(data).then(res => {
            this.dispatch({
                type: ActionTypes.INVOICE_PDF,
                payload: res?.Some || []
            })
            return res
        })
    }

    public async packingSleep(data: any) {
        return this.repository.packingSleep(data).then(res => {
            this.dispatch({
                type: ActionTypes.INVOICE_PDF,
                payload: res?.Some || []
            })
            return res
        })
    }

    public async orderConfirmState(data: any) {
        return await this.repository.orderConfirmState(data)
    }

    public async orderUpdate(data: any) {
        return this.repository.orderUpdate(data).then(() => {
        })
    }

    public async removeOrder(id: number) {
        return this.repository.removeOrder(id).then((res) => {
            return res;
        })
    }

    public async chancelOrderPaper(id: number) {
        return this.repository.chancelOrderPaper(id).then((res) => {
            return res;
        })
    }

    public async sendInvoice(data: any) {
        return this.repository.sendInvoice(data).then(res => {
            this.dispatch({
                type: ActionTypes.SEND_INVOICE,
                payload: res?.Some || []
            })
            return res
        })
    }
    public async getInvoiceInfo(data: any) {
        return this.repository.getInvoiceInfo(data).then(res => {
            return res
        })
    }

    public async printPressed(data: any) {
        return this.repository.printPressed(data).then(res => {
            return res
        })
    }

    public async cardPaymentDetailsPrintPressed(data: any) {
        return this.repository.cardPaymentDetailsPrintPressed(data)
    }

    public async getOrderList(data: any) {
        return await this.repository.getOrderList(data).then(res => {
            this.dispatch({
                type: ActionTypes.GET_ORDER_LIST,
                payload: res.Some
            })
            return res
        })
    }

}